import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import Constructor from '../Constructor/Constructor';
import template from '../../../helpers/template';
import CustomNotify from "../../Notify";
import { I18nContext } from 'utils/I18n/context';

const promoError = 'promoError';

const creativeType = 'promocode';

const PromoCodeConstructor = (props) => {
    const { t } = useContext(I18nContext);
    const constructorMethods = Constructor(props);
    
    const [state, setState] = useState({
        creativeType: props.creativeType || creativeType,
        creativeId: props.creativeId || props.linkId,
        linkId: props.linkId,
        promocode: props.promocode,
        modalIsVisible: props.visible,
        goalEntries: props.goalEntries,
        publisherId: props.publisherId,
        link: {},
        metaParams: {},
        metaParamsmetaParams: {},
        selfieLink: '',
        currentLinkId: '',
        resultLink: '',
        type: props.type,
        codeParams: {},
        promoTitle: props.promocode && props.promocode.title ? props.promocode.title : "",
        description: props.promocode && props.promocode.description ? props.promocode.description : "",
        errors: '',
        modalOptions: {
            promocode: {
                title: t?.constructors?.createLink || 'Create Link',
                pattern: '{{ promocode }}'
            },
            container: {
                title: t?.constructors?.createContainer || 'Create Container',
                pattern: '<iframe src="{{ promocode }}" width="{{ width }}" height="{{ height }}" align="middle">{{ text }}</iframe>'
            }
        }
    });

    useEffect(() => {
        initLink();
    }, []);

    useEffect(() => {
        const isChangeLinkId = state.linkId !== props.linkId;
        let promoTitle = props.promocode ? props.promocode.title : "";
        let description = props.promocode ? props.promocode.description : "";

        setState(prev => ({
            ...prev,
            creativeType: props.creativeType || creativeType,
            creativeId: props.creativeId || props.linkId,
            goalEntries: props.goalEntries,
            publisherId: props.publisherId,
            linkId: props.linkId,
            promocode: props.promocode,
            type: props.type,
            selfieLink: '',
            codeParams: props.codeParams || {},
            access: !!constructorMethods.getFirstGoal() && props.access,
            modalIsVisible: props.visible,
            promoTitle: props.promoTitle || promoTitle,
            description: props.description || description,
            errors: props.errors,
            goalEntryId: props.goalEntryId || constructorMethods.getFirstGoal()
        }));

        if (isChangeLinkId) {
            initLink();
        }
    }, [props]);

    const initLink = useCallback(() => {
        if (!state.linkId) {
            return;
        }
        props.getDataLink(state.linkId, successLink);
    }, [state.linkId, props]);

    const successLink = useCallback((data) => {
        setState(prev => ({
            ...prev,
            link: data
        }));
    }, []);

    const getLinkParams = useCallback(() => {
        let linkIdParam = '?l=' + state.linkId,
            selfieLink = state.selfieLink;

        return selfieLink ? linkIdParam + '&sl=' + encodeURIComponent(selfieLink) : linkIdParam;
    }, [state.linkId, state.selfieLink]);

    const getCode = useCallback(() => {
        let code = state.modalOptions[state.type].pattern;
        let params = {
            ...state.codeParams,
            link: constructorMethods.getResultLink(state.link)
        };

        return template(code, params);
    }, [state, constructorMethods]);

    const setParam = useCallback((e) => {
        if (e.target.value.replace(constructorMethods.getAllowChar(), '') !== e.target.value) {
            constructorMethods.onErrorMsg('notAllowCharMsg');
            return false;
        }

        let metaParams = { ...state.metaParams };
        let promoCode = { ...state.promocode };

        if(!promoCode.settings) {
            promoCode['settings'] = {};
        } else if(promoCode && typeof promoCode.settings === "string") {
            promoCode.settings = JSON.parse(promoCode.settings);
        }

        metaParams[e.target.placeholder] = e.target.value;

        if(!state.promocode || !state.promocode.settings) {
            promoCode['settings'] = {};
        }

        promoCode.settings[e.target.placeholder] = e.target.value;

        setState(prev => ({
            ...prev,
            metaParams: metaParams,
            promocode: promoCode
        }));
    }, [state, constructorMethods]);

    const generatePromoCode = useCallback((e) => {
        let code = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ23456789';
        const charactersLength = 10;
        for (var i = 0; i < charactersLength; i++) {
            var randomPoz = Math.floor(Math.random() * characters.length);
            code += characters.substring(randomPoz,randomPoz+1);
        }
        code = (state.publisherId+code).substr(0, 10)

        let error = code.length ? '' : promoError;

        setState(prev => ({
            ...prev,
            promoTitle: code,
            errors: error
        }));
    }, [state.publisherId]);

    const setPromoCode = useCallback((e) => {
        let error = e.target.value.length ? '' : promoError;

        setState(prev => ({
            ...prev,
            promoTitle: e.target.value,
            errors: error
        }));
    }, []);

    const setDescrioption = useCallback((e) => {
        setState(prev => ({
            ...prev,
            description: e.target.value
        }));
    }, []);

    const close = useCallback(() => {
        props.onClose();
    }, [props]);

    const confirm = useCallback(() => {
        if (state.loading || state.confirmDisabled) {
            return;
        }

        if (!state.promoTitle || !state.promoTitle.length) {
            setState(prev => ({
                ...prev,
                errors: promoError
            }));
            return;
        }

        let params = {
            goalEntryId: state.goalEntryId,
            publisherId: state.publisherId,
            linkId:  state.linkId,
            params: JSON.stringify(state.metaParams),
            promocode: state.promoTitle,
            description: state.description
        };

        props.onSave(params);
        window.location.reload();
    }, [state, props]);

    const edit = useCallback(() => {
        if (!state.promocode.title || !state.promocode.title.length) {
            setState(prev => ({
                ...prev,
                errors: promoError
            }));
            return;
        }

        let params = {
            params: JSON.stringify(state.metaParams),
            id: state.promocode.id,
        };

        props.onEdit(params);
        close();
    }, [state, props, close]);

    if(undefined === state.modalOptions[state.type]) {
        return '';
    }

    if ("object" === typeof state.link && 0 === Object.keys(state.link).length && state.modalIsVisible) {
        return '';
    }
    if (undefined === state.link && state.modalIsVisible) {
        CustomNotify(t?.constructors?.cantCreateUrlForCreativeNoLinksAvailable || 'Error', 'error');
        return '';
    }

    let options = state.modalOptions[state.type];

    let editPromoCode = false;

    if(state.promocode && state.promocode.id) {
        editPromoCode = true;
    }

    return (
        <div className="promocode-construrtor">
            {!state.access
                ? <CustomModal
                    visible={state.modalIsVisible}
                    onClose={props.onClose}
                    onConfirm={props.onClose}
                    confirmName={t?.constructors?.confirm || 'Confirm'}
                    title={options.title}
                    areNoControls={true}
                >

                    <div className="row row-line">
                        <div className="col-sm-12">
                            <span>{t?.constructors?.getAccess || 'Get Access'}.</span>
                        </div>
                    </div>
                </CustomModal>
                : <CustomModal
                    visible={state.modalIsVisible}
                    onClose={props.onClose}
                    onConfirm={editPromoCode ? edit : confirm}
                    confirmName={t?.constructors?.save || 'Save'}
                    title={options.title}
                    areNoControls={false}
                >
                    {constructorMethods.renderGoalEntries()}

                    {constructorMethods.renderParams(creativeType)}

                    {constructorMethods.renderSubMetaParams(creativeType)}

                    {constructorMethods.renderPromoCode()}

                    {constructorMethods.renderPromoCodeDescription()}
                </CustomModal>
            }
        </div>
    );
};

PromoCodeConstructor.propTypes = {
    offer: PropTypes.object.isRequired,
    goalEntryId: PropTypes.string,
    linkId: PropTypes.string,
    visible: PropTypes.bool,
    access: PropTypes.bool,
    type: PropTypes.string,
    getDataLink: PropTypes.func,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    onEdit: PropTypes.func
};

PromoCodeConstructor.defaultProps = {
    type: creativeType,
    getDataLink: () => {},
    onClose: () => {},
    onSave: () => {},
    onEdit: () => {}
};

export default PromoCodeConstructor;